const trainingsData = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/4398896/pexels-photo-4398896.jpeg",
    title: "Mixed Martial Arts",
    description:
      "A complete combat system combining striking, grappling, takedowns, and ground fighting. Perfect for building strength, endurance, discipline, and real-world fighting ability.",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/4761665/pexels-photo-4761665.jpeg",
    title: "Boxing",
    description:
      "Boxing focuses on punches, footwork, timing, and defensive techniques. It helps improve speed, stamina, coordination, and overall cardiovascular fitness while teaching powerful and precise striking.",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/7988954/pexels-photo-7988954.jpeg",
    title: "Brazilian Jiu-Jitsu",
    description:
      "A ground-based martial art focused on submissions, chokes, and joint locks. Ideal for self-defense, technique-based training, and mastering leverage over strength.",
  },
  {
    id: 4,
    img: "https://images.pexels.com/photos/4761344/pexels-photo-4761344.jpeg",
    title: "Gymnastics",
    description:
      "Enhances flexibility, balance, agility, and body control. Excellent for improving athletic performance, coordination, and overall physical conditioning.",
  },
  {
    id: 5,
    img: "https://images.pexels.com/photos/598631/pexels-photo-598631.jpeg",
    title: "Kickboxing",
    description:
      "A high-energy striking sport that improves stamina, reflexes, and power through punches, kicks, and combinations. Great for weight loss and full-body conditioning.",
  },
  {
    id: 6,
    img: "https://images.pexels.com/photos/8038021/pexels-photo-8038021.jpeg",
    title: "Karate",
    description:
      "A traditional martial art focused on discipline, precision, self-control, and powerful striking techniques. Suitable for all ages and skill levels.",
  },
  {
    id: 7,
    img: "https://images.pexels.com/photos/7045738/pexels-photo-7045738.jpeg",
    title: "Taekwondo",
    description:
      "A combat sport that involves grappling and holds, focusing on technique, strength, and strategy. Ideal for building discipline, self-defense skills, and physical fitness.",
  },
  {
    id: 8,
    img: "https://images.pexels.com/photos/7045429/pexels-photo-7045429.jpeg",
    title: "Kung Fu",
    description:
      "A martial art that focuses on throws, takedowns, and joint locks. Ideal for building discipline, self-defense skills, and physical fitness.",
  },
  {
    id: 9,
    img: "https://images.pexels.com/photos/1552108/pexels-photo-1552108.jpeg",
    title: "Weightloss",
    description:
      "A sport that involves lifting weights to improve strength, power, and endurance. Ideal for building discipline, self-defense skills, and physical fitness.",
  },
  {
    id: 10,
    img: "https://images.pexels.com/photos/4754146/pexels-photo-4754146.jpeg",
    title: "Self-Defense",
    description:
      "A sport that involves lifting weights to improve strength, power, and endurance. Ideal for building discipline, self-defense skills, and physical fitness.",
  },
  {
    id: 11,
    img: "https://images.pexels.com/photos/4761344/pexels-photo-4761344.jpeg",
    title: "Personal Training",
    description:
      "One-on-one coaching in Boxing, Kickboxing, MMA, Self-Defence, Karate & Gymnastics focused on faster results, fitness, confidence, and real-world self-protection.",
  },
  {
    id: 12,
    img: "https://images.pexels.com/photos/7045738/pexels-photo-7045738.jpeg",
    title: "Kids MMA",
    description:
      "A fun and structured martial arts program for children aged 3+ that builds confidence, discipline, coordination, self-defence skills, and strong character development.",
  },
  {
    id: 13,
    img: "https://images.pexels.com/photos/7045738/pexels-photo-7045738.jpeg",
    title: "Home Training",
    description:
      "Professional martial arts training at your home with certified personal coaches and complete equipment. Train with Delhi’s most trusted home training academy and achieve fitness, confidence & self-protection.",
  },
];

export default trainingsData;
